import React from 'react';
import { faqItems } from '../data/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQPage = () => {
  return (
    <main>
      {/* Hero Banner */}
      <section className="relative h-[50vh] min-h-[350px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&auto=format&fit=crop&q=80"
            alt="Montana wheat field"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#3B2F1E]/90 via-[#3B2F1E]/50 to-[#2D5016]/30" />
        </div>
        <div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-6">
            Good Grains FAQs
          </h1>
          <p className="text-white/80 text-lg md:text-xl">
            Curious about our grains, where they come from, or how to order? This section covers everything you need to know.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 bg-[#FAF6F0]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={item.id}
                value={`item-${item.id}`}
                className={`rounded-2xl overflow-hidden shadow-md transition-all duration-300 hover:shadow-lg ${
                  index % 2 === 0 ? 'bg-white' : 'bg-[#FEFCF8]'
                }`}
              >
                <AccordionTrigger className="px-6 py-5 text-left hover:no-underline group">
                  <span className="font-serif text-lg font-semibold text-[#3B2F1E] group-hover:text-[#2D5016] transition-colors pr-4">
                    {item.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6">
                  <p className="text-[#3B2F1E]/80 leading-relaxed">
                    {item.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Still Have Questions CTA */}
      <section className="py-16 bg-[#2D5016]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl font-bold text-white mb-4">
            Still Have Questions?
          </h2>
          <p className="text-white/80 mb-8">
            We're here to help! Reach out and we'll get back to you as soon as possible.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:406-607-2302"
              className="px-8 py-3 rounded-lg bg-[#D4A84B] text-[#3B2F1E] font-semibold hover:bg-[#c49a3d] transition-colors"
            >
              Call 406-607-2302
            </a>
            <a
              href="mailto:Rnorton462@gmail.com"
              className="px-8 py-3 rounded-lg border-2 border-white/50 text-white font-semibold hover:bg-white/10 transition-colors"
            >
              Email Us
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default FAQPage;
